import { Injectable, OnInit } from '@angular/core';
import {timer} from 'rxjs';

const FILES = require('./sounds.json');

@Injectable({
  providedIn: 'root',
})
export class AudioPlayerService implements OnInit {

  SOUNDS = new Map(
    [
      ['ringback', {audio: new Audio(FILES['ringback']), volume: 1.0}],
      ['ringing', {audio: new Audio(FILES['ringing']), volume: 1.0}],
      ['beep', {audio: new Audio(FILES['beep']), volume: 1.0}],
      ['answered', {audio: new Audio(FILES['answered']), volume: 1.0}],
      ['rejected', {audio: new Audio(FILES['rejected']), volume: 0.5}],
      ['chat', {audio: new Audio(FILES['chat']), volume: 0.5}],
    ]);

  constructor() {
  }

  // eslint-disable-next-line @angular-eslint/contextual-lifecycle
  ngOnInit(): void {
    for (const sound of this.SOUNDS.values()) {
      sound.audio.volume = 0;
      try {
        sound.audio.play().catch(function (e) {
          console.log('Caught a play error' + JSON.stringify(e));
        });
      } catch (error) {
      }
    }
  }

  play(name: string, relativeVolume: number, loop: boolean) {
    if (typeof relativeVolume !== 'number') {
      relativeVolume = 1.0;
    }

    // console.log('play() [name:%s, relativeVolume:%s]', name, relativeVolume);

    const sound = this.SOUNDS.get(name);

    if (!sound) {
      throw new Error(`unknown sound name "${name}"`);
    }

    try {
      sound.audio.currentTime = 0.0;
      sound.audio.volume = (sound.volume || 1.0) * relativeVolume;
      sound.audio.loop = loop;
      sound.audio.play().then(() => console.log(name + ' played')).catch((e) => {
        console.log('Caught a play error' + JSON.stringify(e));
      });
    } catch (error) {
      console.log('play() | error: %o', error);
    }
  }

  stop(name) {

    const sound = this.SOUNDS.get(name);

    if (!sound) {
      throw new Error(`unknown sound name "${name}"`);
    }

    sound.audio.pause();
    sound.audio.currentTime = 0.0;
  }


  initRigging() {
    this.play('ringing', 0, false);
    timer(1).subscribe(() => this.stop('ringing'))
  }


}
